// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"TX","mainContent":"UX","activeSidebar":"VX"};